<div class="auth__login__panel">
  <div fxLayout="row" class="auth__login__panel__header">
    <div class="auth__login__panel__header-logo">
      <bfx-logo-svg></bfx-logo-svg>
    </div>
    <div fxFlex="50" class="auth__login__panel__header-title">{{ frameTag }}</div>
  </div>
  <div class="auth__login__panel__body">
    <div class="notFoundContent">
      <div fxFlex fxLayout="row" fxLayoutAlign="space-around center">
        <div fxFlex="27" class="notFoundIconSpacing">
          <span class="icon icon-error bfx-icon-xlg"></span>
        </div>
        <div class="notFoundTextSpacing" fxFlex="73" fxLayout="column" fxLayoutAlign="start start">
          <div fxFlex class="title">HTTP 404. Page not found!</div>
          <div fxFlex="50" class="text">
            The requested resources was not found.<br />
            <a role="button" routerLink="/main">Click here to return to the OMS application.</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="auth__login__panel__footer">
    <p class="copyright">&copy; BarracudaFX</p>
  </div>
</div>
